import { equal } from "../../../shared";
import { SubscriptionItem, SubscriptionItemDraft, SubscriptionItemType } from "../types";
import { subscriptionItemToDraft } from "./subscriptionsItemToDraft";

export function isEqual(
  itemA: SubscriptionItemDraft | SubscriptionItem | undefined,
  itemB: SubscriptionItemDraft | SubscriptionItem | undefined
): boolean {
  if (itemA === undefined || itemB === undefined) {
    return equal(itemA, itemB);
  }

  let draftA: SubscriptionItemDraft = "id" in itemA ? subscriptionItemToDraft(itemA) : itemA;
  let draftB: SubscriptionItemDraft = "id" in itemB ? subscriptionItemToDraft(itemB) : itemB;

  // remove "title" from comparison because saved item does not have it
  if (draftA.type === SubscriptionItemType.BulkExport) {
    const { title, ...restPayload } = draftA.payload;
    draftA = {
      ...draftA,
      payload: { ...restPayload, dimensions: restPayload.dimensions.map((dim) => ({ ...dim, fieldName: "" })) },
    };
  }
  if (draftB.type === SubscriptionItemType.BulkExport) {
    const { title, ...restPayload } = draftB.payload;
    draftB = {
      ...draftB,
      payload: { ...restPayload, dimensions: restPayload.dimensions.map((dim) => ({ ...dim, fieldName: "" })) },
    };
  }

  return equal(draftA, draftB);
}
